import { c as _c } from "react/compiler-runtime";
import { Icon } from "@repo/ui/icon";
import { Button } from "@repo/ui/button";
import { FeatureCards } from "@/components/navigation/cards";
import { MenuItemLink } from "@/components/navigation/menu-item-link.component";
import { ActionLink } from "@/components/common/actions/actions.component";
import type { RichMenuItem } from "@/components/navigation/navigation.types";
import { getI18nString } from "@/lib/utils";
interface MobileMenuLevel3Props {
  menu: RichMenuItem;
  onBack: () => void;
}
export function MobileMenuLevel3(t0) {
  const $ = _c(21);
  const {
    menu,
    onBack
  } = t0;
  const cta = menu.actions?.[0];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="chevron-left" className="text-text-primary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== menu.heading) {
    t2 = <span className="typography-body-md-medium pl-1 text-text-primary">{menu.heading}</span>;
    $[1] = menu.heading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onBack || $[4] !== t2) {
    t3 = <button type="button" onClick={onBack} className="flex gap-x-6 items-center py-3">{t1}{t2}</button>;
    $[3] = onBack;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== menu.colour || $[7] !== menu.menuItems) {
    t4 = menu.menuItems && menu.menuItems.map(item => <li key={item._key}><MenuItemLink item={item} colour={menu.colour} iconSize="md" /></li>);
    $[6] = menu.colour;
    $[7] = menu.menuItems;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ul className="flex flex-col gap-y-4 py-5">{t4}</ul>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== cta) {
    t6 = cta?.to && <ActionLink actionTo={cta.to} className="mb-2 inline-block w-fit"><Button variant="blue-filled" size="sm" asChild={true}><span>{getI18nString(cta.text, "Learn more")}</span></Button></ActionLink>;
    $[11] = cta;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== menu.colour || $[14] !== menu.featureCardsLayout) {
    t7 = menu.featureCardsLayout && <div className="border-t border-border-subtle pt-14 pb-4"><FeatureCards layout={menu.featureCardsLayout} colour={menu.colour} /></div>;
    $[13] = menu.colour;
    $[14] = menu.featureCardsLayout;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <>{t3}{t5}{t6}{t7}</>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}